import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    // SurveyHolder
    paperWidthFalse: {
        maxWidth: '800px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '600px',
        }
    },
    rootDialogContent: {
        padding: '0',
        paddingTop: '0 !important',
    },
    rootGridHead: {
        padding: '20px 20px 0 20px',
    },
    rootAccordion: {
        boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
        border: `1px solid white`,
        marginBottom: '20px',
        '&$expandedAccordion': {
            margin: '0 0 20px !important',
        }
    },
    active: {
        border: `1px solid ${themeCommon.lightBlue}`,
        borderRadius: '15px',
    },
    rootNote: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize18px,
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootTypographyNote: {
        width: '50%',
    },
    expandedAccordion: {
        //required
    },
    roundedAccordion: {
        borderRadius: '20px 20px 20px 20px',
        '&:last-child': {
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
        },
        '&:first-child': {
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
        }
    },
    rootAccordionSummary: {
        padding: '20px',
    },
    rootAccordionSummaryForChallenge: {
        padding: '20px 20px 0px 20px',
    },
    rootAccordionSummarySurveyDetail: {
        padding: '0 15px',
        '&$expandedAccordionSummarySurveyDetail': {
            height: '45px',
            minHeight: 'unset',
        }
    },
    expandedAccordionSummarySurveyDetail: {
        //required
    },
    contentAccordionSummary: {
        display: 'unset',
        margin: '0',
        '&$expandedAccordionSummary':{
            margin: '0',
        }
    },
    expandedAccordionSummary: {
        //required
    },

    rootGridContent: {
        background: '#FFFFFF',
        fontSize: themeCommon.fontSize20px,
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    textTitle: {
        fontSize: themeCommon.fontSize20px,
        fontFamily: themeCommon.RobotoBold,
        marginBottom: '10px',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize18px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    textDescription: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize16px,
        opacity: '0.8',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize10px,
        },
    },
    textDescriptionClosed: {
        opacity: '1',
        color: '#4DD091',
    },
    textDescriptionExpired: {
        opacity: '1',
        color: '#DA2A1C',
    },
    containerProrgessBar: {
        marginTop: '20px',
    },
    wrapperProrgessBarCoin: {
        position: 'relative',
    },
    rootCoin:{
        position: 'absolute',
        top: '-50px',
        right: '0',
    },
    rootAccordionDetailsSurvey: {
        padding: '0',
    },
    rootCard: {
        padding: '14px',
    },
    rootTitle: {
        fontFamily: themeCommon.RobotoBold,
        margin: '20px 0 30px',
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize28px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize24px,
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
            fontSize: themeCommon.fontSize20px,
        },
    },
    rootTypographyDate: {
        fontSize: '18px',
    },
    rootLine: {
        border: '1px dashed #3A43BA',
        width: '0px',
        height: '14px',
    },
    rootLineMissed: {
        border: '1px dashed white',
    },
    rootTooltip: {
        position: 'relative',
            marginTop: '100px',
            width: '20px',
        '& > div' : {
            width: '20px',
            height: '1px',
            background: '#C4C4C4',
        }
    },
    rootTooltipChild:{
        '&::before': {
            content: "",
            display: 'block',
            width: '19.5px',
            height: '5px',
            background: '#C4C4C4',
            transform: 'rotate(56deg)',
            position: 'absolute',
            top: '-8px',
            right: '-5px',
        }
    },

    layoutDetail: {
        position: 'absolute',
        right: '0',
        top: 'calc(69px + 222px)',
        width: '33%',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
        maxHeight: '69vh',
        height: '69vh',
        overflowY: 'hidden',
        '&:hover': {
            overflowY: 'auto',
        },
        '@media (max-width: 1400px)': {
            top: 'calc(69px + 150px)',
        },
        [theme.breakpoints.down('lg')]: {
            top: 'calc(69px + 150px)',
        },
    },
    layoutDetailSroll: {
        position: 'fixed',
        top: '0',
        maxHeight: '80vh',
        height: '80vh',
    },
    rootIcon: {
        position: 'absolute',
        right: '0%',
        top: '0%',
        zIndex: '1',
    },
    // rootAccordionSummary: {
    //     minHeight: 'auto !important',
    // },
    contentAccordionSummaryMilestone: {
        margin: '0 !important',
    },
    rootAccordionDetails: {
        padding: '0 !important',
        marginBottom: '20px',
    },
    rootAccordionInformation: {
        boxShadow: 'none',
        marginBottom: '10px',
    },
    rootAccordionSummaryInformation: {
        padding: '0',
    },
    // rootAccordionDetailsInformation: {
    //     paddingLeft: '0', 
    //     paddingRight: '0', 
    // },
    rootGridInfoProgress: {
        marginTop: '1rem',

        [theme.breakpoints.down('lg')]: {
            marginTop: '1rem',
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '1rem',
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '0.5rem',
        },
    },
    rootTypographyHeader: {
        color: themeCommon.lightBlue,
        fontSize: themeCommon.fontSize14px,

        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize12px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize8px,
        },
    },
    rootAccordionSurveyDetail: {
        padding: '10px 10px 30px',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px !important',
        margin: '20px 0',
    },
    rootGridContentContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: '0px 30px;',
        },
    },

    // Dialog CompletedSurveyModal
    rootWrapperTitle: {
        background: themeCommon.lightBlue,
        borderRadius: '5px',
        padding: '20px 0',
    },
    textDialog: {
        fontFamily: themeCommon.RobotoRegular, 
        color: '#FFFFFF',
        padding: '10px',
        textAlign: 'center',
    },
    textDialogTitle: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize24px,
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    textDialogDescription: {
        fontSize: themeCommon.fontSize20px,
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    wrapperRecommendations: {
        background: '#4DD091',
        borderRadius: '5px',
        padding: '5px 0',
        margin: '10px 0',
    },
    textRecommendations: {
        fontSize: themeCommon.fontSize20px,
        padding: '0 5px',
        color: '#FFFFFF',
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    rootContainerCoin: {
        width: '100%',
        // '& > div': {
        //     margin: '0',
        // },
    },
    textContent: {
        fontSize: themeCommon.fontSize14px,
        fontFamily: themeCommon.RobotoBold,
        fontWeight: '700',
        paddingLeft: '5px',
        [theme.breakpoints.down('sm')]: {
            width: '50px',
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootButtonDialog: {
        color: 'white',
        background: themeCommon.lightBlue,
        borderRadius: '15px !important',
        padding: '5px 20px',
        textTransform: 'capitalize',
        marginTop: '15px',
        '&:hover': {
            background: themeCommon.lightBlue,
        },
        fontSize: themeCommon.fontSize20px,
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    paperDialog: {
        borderRadius: '10px',
    },
    rootDialogTitle: {
        color: 'white',
        background: themeCommon.lightBlue,
        padding: '5px',
        textAlign: 'center',
    },
    rootDialogAction: {
        marginBottom: '20px',
        justifyContent: 'center',
    },
    typographyPercent: {
        marginBottom: '15px',
    },
    rootTypographyPercent: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize15px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize13px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootTypographySection: {
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize18px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize15px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },

    // button Load more for Log
    containerLoadmore: {
        margin: '50px 0',
        cursor: 'pointer',
        '& > div': {
            fontSize: themeCommon.fontSize22px,
            fontWeight: 700,
            color: themeCommon.bg_btn,
            [theme.breakpoints.down('xs')]: {
                fontSize: themeCommon.fontSize18px,
            },
        }
    }
}), {
    name: 'SurveyHeadContainer',
    index: 1,
})

export default useStyles